import { percentageSignFilter } from "app/filters/ngFilters";

const defaultFormatter = function () {
    return `
        <span>
            <div class="u-bold">${this.point.name}</div>
            <div>
                ${this.series.name}: 
                <span class="u-bold">
                    ${percentageSignFilter()(this.point.value, 2)}
                </span>
            </div>
        </span>`;
};

export const getHighchartsConfig = () => {
    return {
        chart: {
            height: 253,
            animation: false,
        },
        title: {
            text: undefined,
        },
        tooltip: {
            useHTML: true,
            style: {
                fontSize: "12px",
                fontFamily: "'Roboto', sans-serif",
                color: "#707070",
            },
            formatter: defaultFormatter,
        },
    };
};
